import { del, get, post } from './client';

export interface TcManagedSheet {
  id: string;
  team_id: string;
  title: string;
  spreadsheet_id: string;
  script_id: string | null;
  status: string;
  template_version: string;
  spreadsheet_url: string;
  last_synced_at: string | null;
  created_at: string | null;
}

export interface TcSheetsListResponse {
  sheets: TcManagedSheet[];
  missing_scopes: string[];
  upgraded?: TcManagedSheet[];
}

export async function listTcSheets(teamId: string): Promise<TcSheetsListResponse> {
  return get<TcSheetsListResponse>(`/api/teams/${teamId}/tc-sheets`);
}

export async function createTcSheet(
  teamId: string,
  title?: string
): Promise<{ sheet: TcManagedSheet; bootstrap_expires_at: string }> {
  return post<{ sheet: TcManagedSheet; bootstrap_expires_at: string }>(
    `/api/teams/${teamId}/tc-sheets/create`,
    { title }
  );
}

export async function upgradeTcSheets(teamId: string): Promise<{
  sheets: TcManagedSheet[];
  upgraded: TcManagedSheet[];
}> {
  return post<{ sheets: TcManagedSheet[]; upgraded: TcManagedSheet[] }>(
    `/api/teams/${teamId}/tc-sheets/upgrade`,
    {}
  );
}

export async function deleteTcSheet(
  teamId: string,
  sheetId: string
): Promise<{ deleted: TcManagedSheet; sheets: TcManagedSheet[] }> {
  return del<{ deleted: TcManagedSheet; sheets: TcManagedSheet[] }>(
    `/api/teams/${teamId}/tc-sheets/${sheetId}`
  );
}
